import { createContext } from 'react'

let _holdUntil = 0

export const AuthEffectCtx = createContext<{ prepareSuccess: () => void }>({
  prepareSuccess: () => {},
})

export function prepareAuthSuccessHold(ms = 5000) {
  _holdUntil = Date.now() + ms
}

export function shouldHoldAuthRedirect() {
  return Date.now() < _holdUntil
}
